import React, { useState } from "react";
import "./stulogin.css";
import { Link } from "react-router-dom";
 import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";


const Stu_login = () => {
   const [phone, setPhone] = useState("");
  const navigate = useNavigate();

  const handleSendOtp = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://topfaculty.co.in/api/stu_loginotp.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ stuphone: phone }),  
      });

      const result = await response.json();
      console.log("OTP Send Result:", result);

      if (result.success === true) {
        Swal.fire("Success", result.message, "success").then(() => {
          navigate("/verify-otp", { state: { phone } });
        });
      } else {
        Swal.fire("Error", result.message, "error");
      }
    } catch (err) {
       Swal.fire("Error", "Something went wrong!", "error");
    }
  };

  return (
    <>
      <div id="rs-latest-news" className="rs-courses-details">
        <img
          src="assetsfront/images/stulogin.jpg"
          alt="student registration"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        />
        <div className="container">
          <div className="row rs-latest-list">
            <h2 className="title text-center  mt-4 ">
              Student : <span class="info-color">Sign-In </span>
            </h2>
          </div>
          <div className="row">
            <div className="col-md-3"></div>

            <div className="col-md-6">
              <div className=" ">
                <div className="container h-100">
                  <div className="row h-100 justify-content-center align-items-center">
                    <form
                      className="col-md-12"
                      onSubmit={handleSendOtp}
                      method="post"
                    >
                      <div
                        className="AppForm shadow-lg"
                        style={{
                          borderLeft: "5px solid #c5c5c5",
                          borderRadius: "12px",
                        }}
                      >
                        <div className="row">
                          <div className="col-md-12  p-4 align-items-center ">
                            <div className="AppFormLeft">
                              {/* <h1 className="text-center">Login</h1> */}
                              <div className="form-group position-relative mb-4">
                                <img
                                  src="https://etempahan.pahang.gov.my/img/pic_login.png"
                                  style={{
                                    // border: "3px solid white",
                                    // borderRadius: "205px",

                                    padding: "5px",
                                  }}
                                ></img>

                                <label
                                  className="form-label"
                                  style={{ color: "black" }}
                                >
                                  Enter Register Mobile
                                </label>
                                <input
                                  className="form-control "
                                  type="number"
                                  placeholder="Phone"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  required
                                />
                              </div>

                              <button
                                type="submit"
                                className="btn btn-success btn-block shadow border-0 py-2 text-uppercase "
                              >
                                Login
                              </button>
                              <p className="text-center mt-5">
                                Don't have an account?
                                <Link to={"../studentregister"}>
                                  {" "}
                                  <span>Create your account</span>
                                </Link>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Stu_login;
